import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthVerificationMobile from './auth_verification_mobile.js';
import { API_BASE_URL } from '../config.js';
export default function Auth() {
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false); // إضافة حالة النجاح
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  
  const email = localStorage.getItem('pending_verification_user');

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    if (!email) {
      // If no email is found in localStorage, redirect to login
      navigate('/login');
    }
  }, [email, navigate]);

  const handleChange = (index, value) => {
    // Only allow numbers
    if (value && !/^\d+$/.test(value)) return;

    const newCode = [...code];
    // Take only the last character entered
    newCode[index] = value.slice(-1);
    setCode(newCode);

    // Move to next input if there's a value and not the last input
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

 const handleSubmit = async (mobileCode) => {

    const fullCode = typeof mobileCode === 'string' ? mobileCode : code.join('');

    if (fullCode.length < 6) {
      setError("الرجاء إدخال الرمز كاملاً");
      return;
    }

    setError(null);
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/verify-email/`, { // <-- ضع الـ API المعدل الخاص بك هنا
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          code: fullCode, // نستخدم الرمز المتكامل سواء من الموبايل أو الكمبيوتر
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setLoading(false);
        setSuccess(true);
        // Clear pending user from local storage
        localStorage.removeItem('pending_verification_user');
        // Navigate to login
        setTimeout(() => {
          navigate('/login');
        }, 1500)
      } else {
        // Handle error messages from the backend
        const errorMsg = data.detail || (Object.values(data).map(err => Array.isArray(err) ? err.join(' ') : err).join(' | '));
        setError(errorMsg || "رمز التحقق غير صحيح");
        setLoading(false);
      }
    } catch (err) {
      setError("حدث خطأ في الاتصال بالخادم");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  if (isMobile) {
    return (
      <AuthVerificationMobile 
        error={error}
        loading={loading}
        success={success}
        onVerify={handleSubmit}
      />
    );
  }
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center font-sans" dir="rtl">
      
      {/* Text Container */}
      <div className="text-center mb-10 max-w-md px-4">
        <h1 className="text-2xl sm:text-[28px] font-bold leading-tight text-black" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
          قد قمنا بإرسال رمز التحقق إلى Email .
          <br />
          يُرجى التحقق من صندوق الوارد وإدخال الرمز لإتمام
          <br />
          العملية
        </h1>
        {email && (
          <p className="mt-4 text-gray-600 text-lg" dir="ltr">{email}</p>
        )}
      </div>

      {error && <div className="text-red-500 mb-4 font-bold">{error}</div>}

      {/* Verification Code Inputs Container */}
      <div className="flex flex-row-reverse gap-3 sm:gap-4 md:gap-5 mb-8">
        {code.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            inputMode="numeric"
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-[#D4E4FC] rounded-lg text-center text-2xl md:text-3xl font-semibold text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#90bbf9] transition-all"
            maxLength={1}
            dir="ltr" // Keep input numbers LTR even in RTL layout
          />
        ))}
      </div>

      <button
        onClick={handleSubmit}
        disabled={loading}
        className="px-8 py-3 bg-[#0a428f] text-white rounded-lg text-xl font-bold hover:bg-[#083370] transition-colors disabled:opacity-50"
      >
        {loading ? "جاري التحقق..." : "تحقق"}
      </button>

    </div>
  );
}